import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';
import { ConfirmDialog } from '@gogame/components';

import { stopJob as stopJobSource } from 'scenes/TapjoyBidUpdate/sources/tapjoy-bid-update';
import { stopJob as stopJobKey } from '../queryKeyFactory';

export const useStopJob = () => {
  const showModal = useScreenModalV2(ConfirmDialog);
  const mutation = useMutation(stopJobKey(), stopJobSource, {
    successMessage: () => 'Bid updating stopped',
    refresh: false,
  });

  return [
    async (params) => {
      await showModal({
        title: `Stop Bid Update`,
        confirmActionLabel: 'Stop Bid Update',
        bodyText: `Are you sure you want to stop bid update?`,
      });

      return mutation.mutateAsync(params);
    },
    mutation,
  ];
};
